import { CommentAvatarShapeUtil } from "../../routes/tickets/components/CommentTool/CommentPinUtil";
import { CommentShapeUtil } from "../../routes/tickets/components/CommentTool/CommentUtil";
import { LinkShapeUtil } from "../../routes/tickets/components/LinkShape";

export const customShapeUtils = [
  CommentShapeUtil,
  LinkShapeUtil,
  CommentAvatarShapeUtil,
];
